module.exports = __webpack_public_path__ + "static/media/zero-logo-text.73ac0116.png";